﻿(function (document) {

    if ('NodeList' in window && !NodeList.prototype.forEach) {
        console.info('polyfill for IE11');
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }

    function CollapseElement(element) {
        var menu = document.querySelector(element.dataset.dropdownMenu);
        menu.dataset.dropdownStatus = 'collapsed';
        element.dataset.dropdownStatus = 'collapsed';
        element.classList.remove('navigation__item--expanded');
        menu.classList.remove('navigation__dropdown--expanded');
    }

    function ExpandElement(element) {
        var menu = document.querySelector(element.dataset.dropdownMenu);
        menu.dataset.dropdownStatus = 'expanded';
        element.dataset.dropdownStatus = 'expanded';
        element.classList.add('navigation__item--expanded');
        menu.classList.add('navigation__dropdown--expanded');
    }

    function CollapseAllElements() {
        document.querySelectorAll('[data-dropdown-menu][data-dropdown-status=expanded]').forEach(function (element, index) {
            CollapseElement(element);
        });
    }

    function EnsureScrollableMenuIsCorrectWidth() {
        var container = document.querySelector('.navigation__container');
        if (container == null) {
            return;
        }
        container.style.width = '8000px';
        if (Foundation.utils.is_small_only() || Foundation.utils.is_medium_only()) {

            if (container.offsetHeight > 52) {
                container.style.width = '8000px';
                setTimeout(function () { EnsureScrollableMenuIsCorrectWidth(); }, 200);
                return;
            }

            var width = 0;
            document.querySelectorAll('.navigation__menu').forEach(function (element, index) {
                width += element.offsetWidth;
            });

            width = width * 1.07;

            if (width < document.offsetWidth) {
                width = document.offsetWidth;
            }

            container.style.width = width + 'px';
        } else {
            container.style.width = 'auto';
        }
    }

    document.addEventListener('DOMContentLoaded', function () {

        var navigationElement = document.querySelector('.navigation');
        var navigationDropdownElement = document.querySelector('.navigation__dropdowns');

        if (!(navigationElement == null && navigationDropdownElement == null)) {
            document.addEventListener('click', function (e) {
                if (!(navigationElement.contains(event.target) || navigationDropdownElement.contains(event.target))) {
                    CollapseAllElements();
                }
            });
        }

        var menus = document.querySelectorAll('[data-dropdown-menu]');
        if (menus != null) {
            menus.forEach(function (element, index) {

                element.addEventListener('mouseenter', function (e) {
                    e.preventDefault();
                    if (element.dataset.dropdownStatus == 'expanded') {
                        CollapseElement(element);
                    } else {
                        CollapseAllElements();
                        ExpandElement(element);
                    }

                });

                element.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (element.dataset.dropdownStatus == 'expanded') {
                        CollapseElement(element);
                    } else {
                        CollapseAllElements();
                        ExpandElement(element);
                    }
                });

                if (index == menus.length - 1) {
                    setTimeout(function () { EnsureScrollableMenuIsCorrectWidth(); }, 500);
                }
            });
        }

        var dropdowns = document.querySelectorAll('[data-menu-id]');
        if (dropdowns != null) {
            dropdowns.forEach(function (element, index) {

                element.addEventListener('mouseleave', function (e) {
                    e.preventDefault();
                    CollapseAllElements();
                });
            });
        }

        document.querySelectorAll('[data-dropdown-menu-close]').forEach(function (element, index) {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                CollapseAllElements();
            });
        });

        window.addEventListener('resize', function () {
            setTimeout(function () { EnsureScrollableMenuIsCorrectWidth(); }, 500);
        });


    });
})(document);